import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledTabs = styled(Box)`
  width: 100%;
  color: #fff;

  .css-heg063-MuiTabs-flexContainer {
    border-bottom: 1px solid rgba(136, 136, 136, 1);
  }
`;
